import React, { useState } from "react";
import "./Signup.css";
import axios from "axios";
import { toast } from "react-toastify"; // Import toast from react-toastify
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../shared/BaseUrl";
import { Link } from "react-router-dom";
import logo from "../image/logo.png";
import patternBg from "../image/landing/designer/bg-patterns.webp";
import { FiEye, FiEyeOff } from "react-icons/fi";

const Signup = () => {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const authNavItems = [
    { label: "About Us", path: "/about-us" },
    { label: "Services", path: "/services" },
    { label: "How It Works", path: "/how-it-works" },
    { label: "Testimonials", path: "/testimonials" },
    { label: "Contact", path: "/contact-us" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Password and confirm password do not match.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    setLoading(true); // Show spinner
    try {
      const response = await axios.post(`${BaseUrl}/api/auth/signup`, {
        username,
        email,
        password,
      });

      if (response.data.status === 200) {
        toast.success(response.data.message.toString(), {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        navigate("/login");
      } else {
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      // If signup is successful, handle the response here
      console.log("Signup success:", response.data);
    } catch (error) {
      console.error("Signup error:", error.message);
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Signup failed. Please try again.";
      toast.error(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } finally {
      setLoading(false); // Hide spinner
    }
  };

  return (
    <div
      className="auth-page"
      style={{ "--auth-pattern-image": `url(${patternBg})` }}
    >
      <header className="auth-nav">
        <button
          type="button"
          className="auth-logo-button"
          onClick={() => navigate("/landing")}
          aria-label="Go to landing page"
        >
          <img src={logo} alt="TattQR logo" />
        </button>
        <nav className="auth-nav-links">
          {authNavItems.map((item) => (
            <Link key={item.path} to={item.path}>
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="auth-nav-actions">
          <button
            type="button"
            className="auth-btn auth-btn-outline"
            onClick={() => navigate("/login")}
          >
            Login
          </button>
          <button type="button" className="auth-btn auth-btn-gold active">
            Design My Qr
          </button>
        </div>
      </header>

      <main className="auth-main">
        <section className="auth-card auth-card-signup">
          <span className="auth-corner auth-corner-tl" />
          <span className="auth-corner auth-corner-tr" />
          <span className="auth-corner auth-corner-bl" />
          <span className="auth-corner auth-corner-br" />
          <div className="auth-card-inner">
            <h1 className="auth-title">Create Your Account</h1>
            <p className="auth-subtitle">
              Start tracking, creating, and growing with smart QR tools.
            </p>

            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-field">
                <input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoComplete="username"
                  required
                />
              </div>

              <div className="auth-field">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                  required
                />
              </div>

              <div className="auth-field auth-field-password">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="auth-eye-toggle"
                  onClick={() => setShowPassword((prev) => !prev)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>

              <div className="auth-field auth-field-password">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="auth-eye-toggle"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  aria-label={
                    showConfirmPassword ? "Hide confirm password" : "Show confirm password"
                  }
                >
                  {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>

              <button type="submit" className="auth-submit-btn" disabled={loading}>
                {loading ? "Creating Account..." : "Create Account"}
              </button>
            </form>

            <p className="auth-switch-text">
              Already have an account? <Link to="/login">Log In</Link>
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Signup;
